if (!customElements.get('features-slider')) {
  class FeaturesSlider extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      scrollbar: '.js-slider-dots',
    };
    settings = {
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: this.hasAttribute('slider-autoplay')
        ? {
            delay: this.getAttribute('slider-autoplay'),
          }
        : false,
      breakpoints: {
        650: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
      scrollbar: {
        bulletActiveClass: 'active',
        el: this.selectors.scrollbar,
        renderBullet: function (index, className) {
          return `
            <div
              class="slider-dot"
              data-dot-index="${index}"
              ${index == 0 && 'active'}
            ></div>
          `;
        },
      },
    };
    slider = undefined;
    id = undefined;
    dotContainers = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
      this.dotContainer = this.querySelector(this.selectors.pagination);

      this.dotContainer.addEventListener('click', (event) =>
        this.onDotClick(event),
      );

      this.slider?.on('slideChange', this.updateDots.bind(this));
    }

    /**
     * Update active dots
     * @param {Object} e Event
     */
    updateDots(e) {
      const activeIndex = e.activeIndex;

      this.dotContainer.querySelectorAll('[data-dot-index]').forEach((dot) => {
        if (dot.dataset.dotIndex == activeIndex) {
          dot.setAttribute('active', true);
          return;
        }

        dot.removeAttribute('active');
      });
    }

    /**
     * Handle dot click.
     *
     * @param {Event} event
     */
    onDotClick(event) {
      const index = event.target.getAttribute('data-dot-index');
      if (!index) return;
      this.slider.slideTo(index);
    }
  }
  customElements.define('features-slider', FeaturesSlider);
}
